import type { Message } from '~/types/local-types'
import capitalize from 'lodash.capitalize'
import { useTranslation } from '~/composables/useTranslation'
import { webshopSettings } from '~/store/webshopSettings'
import { DispatchTypeOrderBuddy } from '~/types/orderbuddy-types'

export function isCompletelyClosed (): boolean {
    return !!webshopSettings()?.global?.emergencyBrake?.closedTemporarily
}

export function isClosedForDispatchType (dispatchType: DispatchTypeOrderBuddy): boolean {
    if (dispatchType === DispatchTypeOrderBuddy.DELIVER && webshopSettings()?.global?.emergencyBrake?.deliveryClosedTemporarily) {
        return true
    } else if (dispatchType === DispatchTypeOrderBuddy.PICK_UP && webshopSettings()?.global?.emergencyBrake?.pickupClosedTemporarily) {
        return true
    }
    return false
}

export function getDelayForDispatchType (dispatchType: DispatchTypeOrderBuddy): number | boolean {
    if (dispatchType === DispatchTypeOrderBuddy.DELIVER && webshopSettings()?.global?.emergencyBrake?.deliveryMinTimeTemporarily) {
        return webshopSettings()?.global?.emergencyBrake?.deliveryMinTimeTemporarily ?? 0
    } else if (dispatchType === DispatchTypeOrderBuddy.PICK_UP && webshopSettings()?.global?.emergencyBrake?.pickupMinTimeTemporarily) {
        return webshopSettings()?.global?.emergencyBrake?.pickupMinTimeTemporarily ?? 0
    }
    return false
}

export function getEmergencyBreakNotification (dispatchType: DispatchTypeOrderBuddy): Message | Record<string, never> {
    const translationPrefix = dispatchType === DispatchTypeOrderBuddy.DELIVER ? 'delivery' : 'pickup'
    if (isCompletelyClosed()) {
        return {
            key: 'completelyClosed',
            message: `${capitalize(useTranslation('shopPage.emergencyBreak.closedTemporarily'))}. ${capitalize(useTranslation('shopPage.emergencyBreak.apologies'))}.`,
            type: 'error'
        }
    } else if (isClosedForDispatchType(dispatchType)) {
        return {
            key: 'closedForDispatchType',
            message: `${capitalize(useTranslation(`shopPage.emergencyBreak.${translationPrefix}ClosedTemporarily`))}. ${capitalize(useTranslation('shopPage.emergencyBreak.apologies'))}.`,
            type: 'error'
        }
    } else if (getDelayForDispatchType(dispatchType)) {
        // TODO: Add delay times to the emergency break messages
        return {
            key: 'delayForDispatchType',
            message: `${capitalize(useTranslation(`shopPage.emergencyBreak.${translationPrefix}MinTimeTemporarily`))} ${useTranslation('shopPage.emergencyBreak.with')} ${getDelayForDispatchType(dispatchType)} ${useTranslation('shopPage.emergencyBreak.minutes')}. ${capitalize(useTranslation('shopPage.emergencyBreak.apologies'))}.`,
            type: 'info'
        }
    }
    return {}
}

export function getEmergencyBreakActive (dispatchType: DispatchTypeOrderBuddy) {
    return Object.keys(getEmergencyBreakNotification(dispatchType)).length
}
